import { render } from 'react-dom'
import ModalContainer from '@/components/commons/Modal/Modal'

class ModalService {
  constructor () {
    this.inited = false
    this.showModal = true
    this.component = null
    this.modalType = 'sm'
  }

  start (fullContent) {
    this.inited = true
    render(
      <ModalContainer fullContent={fullContent} ref={ref => (this.modalComponent = ref)} showModal={this.showModal} modalType={this.modalType} modalContent={this.component} />,
      document.getElementById('appModalContainer')
    )
  }

  open (component, fullContent = false) {
    this.component = component
    if (!this.inited) this.start(fullContent)
    else this.modalComponent.updateState('modalContent', component)
    this.modalComponent.updateState('showModal', true)
    this.modalComponent.updateState('fullContent', fullContent)
  }

  close () {
    this.modalComponent.updateState('showModal', false)
  }
}

export default new ModalService()
